<template>
    <div class="login-body" :class="'login-body-' + (theme === undefined || theme == 'dark' ? 'dark' : 'light')">
        <!--<img src="@/assets/images/login-bg.jpg" class="bg">-->
        <!-- <video
            class="bg-video"
            playsinline="playsinline"
            autoplay="autoplay"
            muted="muted"
            loop="loop"
        >
            <source src="@/assets/images/mp4/bg.mp4" type="video/mp4" />
        </video> -->
        <div class="login-container">
            <div class="login-container-content">
                <div class="container-fluid px-4 px-lg-0">
                    <main class="form-signin">
                        <form class="text-center">
                            <div class="form-header mb-5 fw-normal w-100">
                                {{ TR.login_title }}
                            </div>

                            <div class="form-floating">
                                <input
                                    type="email"
                                    class="form-control border-0 border-bottom border-secondary bg-transparent mb-2"
                                    id="floatingInput"
                                    :autofocus="email == '' ? true : false"
                                    autocomplete="off"
                                    placeholder=""
                                    v-model="email"
                                    @input="changeInput"
                                    @keyup.enter="auth"
                                />
                                <label for="floatingInput">{{
                                    TR.username
                                }}</label>
                            </div>
                            <div class="form-floating">
                                <input
                                    type="password"
                                    class="form-control border-0 border-bottom border-secondary bg-transparent"
                                    id="floatingPassword"
                                    :autofocus="email == '' ? false : true"
                                    autocomplete="off"
                                    placeholder=""
                                    v-model="password"
                                    @input="changeInput"
                                    @keyup.enter="auth"
                                />
                                <label for="floatingPassword">{{
                                    TR.password
                                }}</label>
                            </div>

                            <button
                                class="w-100 btn btn-lg btn-dark text-light mt-5"
                                type="button"
                                @click="auth"
                            >
                                {{ TR.signin }}
                            </button>
                            <p
                                class="mt-5 text-secondary footerInfo"
                                v-html="footerInfo"
                            ></p>
                        </form>
                    </main>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import { onMounted, ref, watchEffect } from "vue";

    import { useStore } from '@/system_modules/store';

    import { useRouter, useRoute } from "vue-router";
    import { G, ajax } from "@/_common";

    export default {
        title: "login_title",
        name: "Login_Black_FW",
        props:{
            theme:{
                type: String,
                default: 'dark'
            }
        },
        setup(props) {
            const store = useStore();
            const router = useRouter();
            const route = useRoute();

            const TR = ref({});

            watchEffect(() => {
                TR.value = store.getTranslation();
            });

            const email = ref("");
            const password = ref("");
            const loginError = ref(false);
            const footerInfo = G.footerPowered.replace('footer-info-link', 'text-' + ((props.theme === undefined || props.theme == 'dark') ? 'light' : 'dark'));

            onMounted(() => {
                email.value = ( G.hasClientData("store_adm_username") ) ? G.getClientData("store_adm_username") : '';
                G.removeClientData("AUTH_TOKEN");
            });

            const changeInput = () => {
                loginError.value = false;
            };

            const auth = async (e) => {
                e.preventDefault();
                loginError.value = false;

                if( email.value != '' && password.value != '' ){
                    let loginData = new FormData();
                    loginData.append("email", email.value);
                    loginData.append("password", password.value);

                    await ajax({
                        method: "post",
                        url: store.getLogin(),
                        data: loginData,
                        // content_type: 'application/json',
                        // data: {
                        //     "email": email.value,
                        //     "password": password.value,
                        // },
                        success: async (e) => {
                            let res = e.data || null;
                            if (res && res.token && res.token.length > 0) {
                                G.token = res.token;
                                G.setClientData("AUTH_TOKEN", res.token);
                                G.setClientData("store_adm_username", email.value);

                                G.parseTokenPermission();

                                if (
                                    route.query &&
                                    route.query.redirect &&
                                    route.query.redirect != ""
                                )
                                    router.push(route.query.redirect);
                                else {
                                    // router.push({name: 'agenda'});
                                    router.push({ path: "/" });
                                    // router.push('/');
                                }
                            }
                            // else {
                            //     G.removeClientData("AUTH_TOKEN");
                            // }
                        },
                        error: (error) => {
                            var res = error.response || {};
                            if (
                                res.status == 422 &&
                                document.getElementsByClassName("login-error-msg-div")
                                    .length
                            ) {
                                document.getElementsByClassName(
                                    "login-error-msg-div"
                                )[0].innerHTML = res.data.detail;
                            }
                            loginError.value = true;

                            // G.removeClientData("AUTH_TOKEN");
                        },
                    });
                }
            };

            return {
                G,
                email,
                password,
                loginError,
                auth,
                footerInfo,
                TR,
                changeInput,
            };
        },
    };
</script>


<style lang="scss">
    .login-body{
        background-image: url('@/assets/images/login-bg.jpg');
        background-repeat: no-repeat;
    }

    .login-info-side{
        position: relative;
        color: #fff;
        z-index: 5;
    }
    img.bg {
        /* Set rules to fill background */
        display: block;;
        min-height: 100%;
        min-width: 1544;

        /* Set up proportionate scaling */
        width: 90%;
        height: auto;

        /* Set up positioning */
        position: fixed;
        bottom: 0;
        right: 0;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
    }

    .login-body {
        width: 100vw;
        height: 100vh;
        position: fixed;
        // background: url("@/assets/images/login-bg.jpg") no-repeat bottom right fixed !important;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
        // position: relative;
    }
    .login-body:before {
        content: "";
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        // background-color: rgba(42, 85, 85, 255);
        background-color: rgba(0, 0, 0, 1);
        // background: url("@/assets/images/login-bg.jpg") rgba(42, 85, 85, 10) no-repeat center center scroll !important;
        opacity: 0.7;
        z-index: 1;
    }

    // video.bg-video {
    //     position: fixed;
    //     top: 50%;
    //     left: 50%;
    //     min-width: 100%;
    //     min-height: 100%;
    //     width: auto;
    //     height: auto;
    //     transform: translateX(-50%) translateY(-50%);
    //     z-index: 0;
    // }

    .login-container {
        position: relative;
        overflow: hidden;
        height: auto;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .login-container:before {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        height: 100%;
        width: 100%;
    }
    .login-container .login-container-content {
        position: relative;
        width: 32rem;
        max-width: 50rem;
        padding-top: 4rem;
        padding-bottom: 3rem;
    }
    .login-container .login-container-content h3,
    .login-container .login-container-content .form-header {
        font-size: 2rem;
    }
    .login-container .login-container-content p {
        font-size: 1.2rem;
    }
    .login-container .login-container-content p strong {
        font-weight: 700;
    }

    .login-body-dark .login-container:before{
        // background-color: rgba(0, 0, 0, 0.85);
        background-color: rgba(4, 9, 7, 0.9);
    }
    .login-body-light .login-container:before{
        background-color: rgba(255, 255, 255, 0.9);
    }

    .login-body-light .form-floating label{
        color: #777777 !important;
    }
    .login-body-dark .form-floating label{
        color: #aaaaaa !important;
    }
    .login-body-light .form-floating input, .login-body-light form .form-header{
        color: #000000 !important;
    }
    .login-body-dark .form-floating input, .login-body-dark form .form-header{
        color: #ffffff !important;
    }

    @media (max-width: 578px) {
        .login-container .login-container-content {
            padding-top: 0;
            padding-bottom: 0;
            padding-left: 0rem;
            padding-right: 0rem;
        }
    }
    @media (min-width: 992px) {
        .login-container {
            height: 100vh;
            width: 55vw;
            min-height: 0;
            padding-bottom: 0;
        }
        .login-container:before {
            transform: skewX(-10deg);
            transform-origin: top right;
        }
        .login-container .login-container-content {
            padding-top: 0;
            padding-bottom: 0;
            padding-left: 2rem;
            padding-right: 7rem;
        }
        .login-container .login-container-content h3,
        .login-container .login-container-content .form-header {
            font-size: 2rem;
        }
        .login-container .login-container-content p {
            font-size: 1.3rem;
        }
    }

    @media (min-width: 1200px) {
        .login-container {
            width: 50vw;
        }
    }

    @media (pointer: coarse) and (hover: none) {
        // body {
        //     background: url("@/assets/images/login-bg.jpg") #2a5555 no-repeat bottom center scroll !important;
        //     background-size: cover;
        //     // background-color: transparent !important;
        // }
        body video {
            display: none;
        }
        .login-container{
            height: 100vh;
        }
    }

    @media screen and (max-width: 1024px) { /* Specific to this particular image */
        img.bg {
            // display: none;
            // left: 50%;
            width: auto;
            // top: 0;
            // left: 0;
            // margin-left: 12px;   /* 50% */
        }
        .login-container{
            height: 100vh;
        }
    }

    .footerInfo{
        font-size: 0.75rem !important;
    }
</style>

